<template>
  <div :id="data.id" class="car">
    <div class="car__top container_wide">
      <div class="car__name-benefit-wrapper mobile">
          <div class="car__name-wrapper">
            <p class="car__name">
							{{ data.brand }} <span v-html="data.name"></span>
						</p>
						<p v-if="data.new" class="car__new">Новый</p>
          </div>
          <div v-if="data.benefit" class="car__benefit">
            <img src="../../images/ico_profit.png" alt="">
            <p>Выгода до<br/><b>{{ data.benefit }}</b><span> руб.</span><sup>*</sup></p>
          </div>
					<div v-if="data.benefitText" class="car__benefit">
            <img src="../../images/ico_profit.png" alt="">
            <p><b>{{ data.benefitText }}</b></p>
          </div>

          <div v-for="(offer, v) in [data.offers[0]]" :key="`offer-${v}`" :class="['car__offer', offer.icon, offer.extra, 'mobile']">
            <span v-html="offer.text"></span>
          </div>
        </div>
      <div class="car__image-wrapper">
        <div class="car__offers">
          <div v-for="(offer, v) in data.offers" :key="`offer-${v}`" :class="['car__offer', offer.icon, offer.extra]">
            <span v-html="offer.text"></span>
          </div>
        </div>
        <img class="car__cover" :src="data.cover" alt="">
        <div class="car__gifts">
          <div class="car__gift">
            <span>Комплект шин<br>
              <b>в подарок!</b>
            </span>
          </div>
					<div v-if="data.fuel_92" class="car__gift fuel">
            <span>Подходит<br>
              <b>АИ-92*</b>
            </span>
          </div>
          <div v-if="data.id === 'j7'" class="car__icons">
            <!-- <img src="../../images/top.svg" /> -->
            <!-- <img src="../../images/grand-pre.svg" /> -->
            <!-- <img src="../../images/win.svg" />s -->
            </div>
          <div v-for="(offer, v) in data.offers.slice(1)" :key="`offer-${v}`" :class="['car__offer', offer.icon, offer.extra, 'mobile']">
            <span v-html="offer.text"></span>
          </div>
        </div>
      </div>
      <div class="car__data">
        <div class="car__name-benefit-wrapper">
          <div class="car__name-wrapper">
            <p class="car__name">
							{{ data.brand }} <span v-html="data.name"></span>
						</p>
						<p v-if="data.new" class="car__new">Новый</p>
          </div>
          <div v-if="data.benefit" class="car__benefit">
            <img src="../../images/ico_profit.png" alt="">
            <p>Выгода до<br/><b>{{ data.benefit }}</b><span> руб.</span><sup>*</sup></p>
          </div>

					<div v-if="data.benefitText" class="car__benefit">
            <img src="../../images/ico_profit.png" alt="">
            <p><b>{{ data.benefitText }}</b></p>
          </div>
        </div>
        <div class="car__gallery-wrapper mobile">
          <div class="car__gallery container_wide">
            <img v-for="(gi, n) in data.gallery" class="car__gallery-image" :src="gi" alt="" @click="getFullSlider({ slides: data.gallery, activeIndex: n })">
          </div>
        </div>
        <ul class="car__advantages">
          <li v-for="(adv, i) in data.advantages" :key="`adv-${i}`" class="car__advantage" v-html="adv"></li>
        </ul>
        <div class="car__buttons">
          <button v-for="(btn, j) in data.buttons" class="car__button button button_blue" @click="getCall('sale')">{{ btn }}</button>
        </div>
      </div>
    </div>
    <div class="car__gallery-wrapper">
      <div class="car__gallery container_wide">
        <img v-for="(gi, n) in data.gallery.slice(0, 4)" class="car__gallery-image" :src="gi" alt="" @click="getFullSlider({ slides: data.gallery, activeIndex: n })">
      </div>
    </div>
  </div>
</template>

<script>
import Mixin from "../../common/mixin";

export default {
	name: "car",
	mixins: [Mixin],
	props: {
		data: {
			type: Object,
			required: true,
			isMounted: false,
		},
	},
	mounted() {
		this.isMounted = true;
	},
};
</script>

<style scoped lang="scss">
@import "../../styles/constants.scss";

.car {
	.container_wide {
		max-width: 1200px;
	}

	&__image-wrapper {
		position: relative;
		display: flex;
		flex-direction: column;
		gap: 20px;
		width: 80%;
		padding-top: 40px;

		&::before {
			content: "";
			position: absolute;
			top: 0;
			right: 15%;
			z-index: 1;
			display: block;
			width: 100%;
			height: 100%;
			background: #e7e7e7;
			transform: skew(-20deg);
		}
	}

	&__icons {
		display: flex;
		gap: 15px;
		margin-left: 10px;
		align-items: center;

		img {
			height: 70px;
		}
	}

	&__top {
		display: flex;
		justify-content: space-between;
		gap: 40px;
	}

	&__name-wrapper {
		position: relative;
		width: max-content;
	}

	&__name {
		margin-bottom: 15px;
		font-size: 50px;
		font-weight: 600;
		text-transform: uppercase;
		color: #1b1d23;
	}

	&__new {
		position: absolute;
		top: -1.5em;
		right: -3em;
		font-size: 1.5em;
		font-weight: 700;
		border-radius: 0.5em;
		padding: 0.1em 0.5em;
		background: $red;
		color: white;
	}

	&__offers,
	&__cover,
	&__gifts {
		position: relative;
		z-index: 2;
	}

	&__offers {
		display: flex;
		gap: 5%;
		padding-left: 20px;
	}

	&__offer {
		display: flex;
		align-items: center;
		height: 80px;

		&.credit-card {
			background: url(../../images/credit-cards.png) 5% 50% no-repeat;
			font-size: 22px;
		}

		&.sign {
			padding-left: 50px;
			font-size: 18px;
			font-weight: 600;
			background: url(../../images/ico_sign.png) 0 50% no-repeat;
			text-transform: uppercase;
		}
	}

	&__cover {
		width: 100%;
		max-width: 730px;
	}

	&__gifts {
		margin-bottom: 20px;
		display: flex;
		gap: 5%;
	}

	&__gift {
		position: relative;
		display: flex;
		align-items: center;
		height: 90px;
		padding-left: 75px;
		color: #000;
		font-size: 20px;
		font-weight: 700;
		z-index: 1;
		text-decoration: none;

		&::before {
			content: "";
			display: block;
			width: 90px;
			height: 90px;
			border-radius: 50%;
			background: #fff;
			position: absolute;
			left: 25px;
			top: 0;
			z-index: -1;
		}

		&::after {
			content: "";
			display: block;
			width: 65px;
			height: 65px;
			background: url(../../images/tire_black.png) 50% no-repeat;
			position: absolute;
			left: 0;
			top: 8px;
			z-index: 2;
		}

		b {
			color: $primary;
		}
	}

	&__gift.fuel {
		&::after {
			background: url(../../images/gas-station.svg) 50% no-repeat;
		}
	}

	&__benefit {
		display: flex;
		align-items: center;
		gap: 15px;
		font-weight: bold;

		b {
			font-size: 30px;
			color: $primary;
		}
	}

	&__advantages {
		display: flex;
		flex-direction: column;
		gap: 12px;
		margin: 32px 0;
		list-style-type: none;
	}

	&__advantage {
		position: relative;
		padding-left: 40px;

		&::before {
			content: "";
			width: 24px;
			height: 1px;
			position: absolute;
			top: 9px;
			left: 0;
			background: #000;
		}
	}

	&__buttons {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	&__button {
		width: 370px;
	}

	&__gallery-wrapper {
		padding-bottom: 35px;
		background: url(../../images/car_gallery_bg.jpg) 50% 100% no-repeat;
	}

	&__gallery {
		display: flex;
	}

	&__gallery-image {
		width: calc(100% / 4);
		cursor: pointer;
	}

	.mobile {
		display: none;
	}
}

@media (max-width: 1200px) {
	.car {
		.container_wide {
			max-width: 960px;
		}

		&__new {
			font-size: calcFontSize(14, 20, 360, 1200);
		}
	}
}

@media (max-width: 960px) {
	.car {
		.container_wide {
			max-width: 720px;
		}

		&__top {
			flex-direction: column;
			margin-bottom: 40px;
		}

		&__image-wrapper {
			width: 100%;
		}

		&__button {
			width: 100%;
		}

		&__name-benefit-wrapper:not(.mobile),
		&__gallery-wrapper:not(.mobile) {
			display: none;
		}

		.mobile {
			display: block;
		}

		&__name-benefit-wrapper.mobile {
			display: flex;
			align-items: center;
			justify-content: space-between;
			gap: 20px;
		}

		&__name {
			margin: 0;
		}

		&__gallery-wrapper.mobile {
			display: block;
			padding: 0;
			background: none;
		}

		&__gallery.container_wide {
			padding: 0;
		}
	}
}

@media (max-width: 720px) {
	.car {
		.container_wide {
			max-width: initial;
		}

		&__top {
			margin-bottom: 20px;
		}

		&__name {
			font-size: 32px;
		}

		&__offers {
			display: none;
		}

		&__gifts {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			gap: 5px;
		}

		&__icons img {
			height: calcFontSize(30, 40, 480, 640);
		}

		&__gifts &__offer {
			display: flex;
		}

		&__offer,
		&__gift {
			font-size: calcFontSize(11, 14, 320, 720) !important;
		}

		&__gift::before {
			width: 80px;
			height: 80px;
		}

		&__offer.credit-card {
			grid-column: 2;
			font-size: calcFontSize(12, 14, 320, 720) !important;
		}

		&__offer.sign {
			grid-column: 2;
		}

		&__offer.sign.extra {
			grid-column: 1;
			grid-row: 2;
		}

		&__gallery-wrapper {
			padding: 20px 0;
			background-position: 100% 0;
		}

		&__benefit {
			grid-row: 2;
		}

		&__name-benefit-wrapper.mobile {
			display: grid;
			grid-template-columns: repeat(2, 1fr);
			grid-template-rows: repeat(2, 1fr);
			gap: 10px;
		}

		&__name-benefit-wrapper.mobile &__offer {
			position: relative;
			display: flex;
			align-items: center;
			grid-column: 2;
			grid-row: span 2;
			justify-self: flex-end;
			background: none;

			&::before {
				content: "";
				position: absolute;
				top: 0;
				left: 0;
				z-index: 1;
				display: block;
				width: 65px;
				height: 65px;
				background: url(../../images/credit-cards.png) no-repeat center/contain;
				filter: grayscale(100%) invert(20%);
			}

			span {
				position: relative;
				z-index: 2;
			}
		}

		&__buttons {
			gap: 5px;
		}
	}
}

@media (max-width: 480px) {
	.car {
		&__gifts {
			display: grid;
			grid-template-columns: repeat(2, 1fr);
		}

		&__icons img {
			height: calcFontSize(22, 30, 320, 480);
		}

		&__offer.extra.mobile {
			grid-column: 1;
			grid-row: 1;
		}

		&__offer.sign {
			grid-column: 2;
			grid-row: 1;
		}

		&__name-benefit-wrapper.mobile {
			grid-template-columns: 1fr;
		}

		&__name-benefit-wrapper.mobile &__offer {
			grid-column: 1;
			grid-row: auto;
			justify-self: flex-start;

			&::before {
				width: 70px;
				height: 70px;
			}

			span {
				font-size: 16px;
			}
		}
	}
}
</style>
